<script lang="ts" setup>
import InputOtp from 'primevue/inputotp';
import type {
  OtpInputSize,
  OtpInputVariant,
} from '~/types/components/base/OtpInput';

/**
 * https://primevue.org/inputotp/#api.inputotp
 */
const {
  length = 4,
  placeholder = undefined,
  variant = undefined,
  size = undefined,
  errorMessage = undefined,

  center = true,
  mask = false,
  integerOnly = true,
  disabled = false,
  loading = false,
  invalid = false,
} = defineProps<{
  length?: number;
  placeholder?: string;
  variant?: OtpInputVariant;
  size?: OtpInputSize;
  errorMessage?: string;

  center?: boolean;
  mask?: boolean;
  integerOnly?: boolean;
  disabled?: boolean;
  loading?: boolean;
  invalid?: boolean;
}>();
</script>

<template>
  <InputOtp
    v-bind="$attrs"
    :length="length"
    :placeholder="placeholder"
    :variant="variant"
    :size="size"
    :mask="mask"
    :integer-only="integerOnly"
    :disabled="disabled"
    :loading="loading"
    :invalid="invalid"
    class="app-otp-input"
    :class="{
      'p-inputotp--centered': center,
    }"
  >
    <template #default="{ attrs, events }">
      <slot :attrs="attrs" :events="events" />
    </template>
  </InputOtp>

  <p v-if="!!errorMessage" class="otp-error-message mt-2 w-full">
    {{ errorMessage }}
  </p>
</template>

<style lang="scss" scoped>
.app-otp-input {
  --p-inputotp-gap: 16px;

  :deep(.p-inputtext) {
    &.p-invalid {
      border-color: var(--p-inputtext-border-color);
      &:focus {
        border-color: var(--p-inputtext-focus-border-color) !important;
      }
      &:last-child {
        border-color: var(--p-inputtext-invalid-border-color);
      }
    }
  }
}
.otp-error-message {
  font-family: $font-family-secondary;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0;
  text-align: center;
  color: #df5a45;
}

:deep(.p-inputotp-input) {
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
}
</style>
